module.exports = __webpack_public_path__ + "img/tarj2-4.c1d91ae9.svg";